export const resolveTopPredictionDisplayDate = (meta, selectedHorizon) => (
  meta?.horizonDates?.[selectedHorizon]
  || meta?.predictionDate
  || meta?.date
);
